// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"D_b4","breadcrumbs__link":"D_b5","breadcrumbs__link__active":"D_b6","breadcrumbs__span":"D_b7"};